export default "__VITE_ASSET__D4IA4NQ0__"